<ion-avatar  [ngStyle]="{ 'background': Color }" class="flex-center">
  {{ Initials }}
</ion-avatar>